import { Component, OnInit, ViewEncapsulation, ViewChild, EventEmitter, Inject } from '@angular/core';
import { startWith, takeUntil, tap, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PropertiesService } from 'app/services/properties.service';
import { BookingsCreateModalComponent } from 'app/main/holiday-rentals/bookings/bookings-create-modal/bookings-create-modal.component';
import { MatCalendar, MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-property-bookings',
  templateUrl: './property-bookings.component.html',
  styleUrls: ['./property-bookings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PropertyBookingsComponent implements OnInit {

  private calendarReload: EventEmitter<any>;
  private _unsubscribeAll: Subject<any>;
  bookings = [] as any;
  loadingBookings = false;
  @ViewChild(MatCalendar, { static: false }) calendar: MatCalendar<Date>;
  searchDialogRef: any;
  constructor(
    public matDialogRef: MatDialogRef<PropertyBookingsComponent>,
    private _propertiesService: PropertiesService,
    private _matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public id: any
  ) {
    this._unsubscribeAll = new Subject();
    this.calendarReload = new EventEmitter();
  }

  ngOnInit(): void {
    this.calendarReload
      .pipe(
        startWith(''),
        takeUntil(this._unsubscribeAll),
        tap(() => this.loadingBookings = true),
        switchMap(() => {
          return this._propertiesService.getPropertyBookings(this.id);
        })
      )
      .subscribe((data: any) => {
        if (data) {
          this.bookings = data;
        }
        setTimeout(() => {
          this.calendar.updateTodaysDate();
          this.loadingBookings = false;
        }, 1000);
        
      });
  }

  // Disable Dates
  CalendarFilter = (date: any): boolean => {
    const calendarDate = new Date(date._d).getTime();
    for (const booking of this.bookings) {
      if (booking.status === 'blocked') {
        for (const element of booking.booked_dates) {
          const bookingDate = element.split('-');
          if (new Date(parseInt(bookingDate[2], 10), parseInt(bookingDate[1], 10) - 1, parseInt(bookingDate[0], 10)).getTime() === calendarDate) {
            return false;
          }
        }
      }
    }
    return true;
  }
  // Highlighting Dates
  dateClass(): any {
    return (date: any): MatCalendarCellCssClasses => {
      const calendarDate = new Date(date._d).getTime();

      for (const booking of this.bookings) {
        for (let i = 0; i < booking.booked_dates.length; i++) {
          const bookingDate = booking.booked_dates[i].split('-');
          if (new Date(parseInt(bookingDate[2], 10), parseInt(bookingDate[1], 10) - 1, parseInt(bookingDate[0], 10)).getTime() === calendarDate) {

            if (booking.status === 'active' && i === 0) {
              return 'lower-diagonal-active';
            }
            else if (booking.status === 'active' && i === booking.booked_dates.length - 1) {
              return 'upper-diagonal-active';
            }
            else if (booking.status === 'active') {
              return 'active';
            }
            else if (booking.status === 'blocked') {
              return 'blocked';
            }
            else if ((booking.status === 'deposit received' || booking.status === 'security deposit') && i === 0) {
              return 'lower-diagonal-green';
            }
            else if ((booking.status === 'deposit received' || booking.status === 'security deposit') && i === booking.booked_dates.length - 1) {
              return 'upper-diagonal-green';
            }
            else if (booking.status === 'deposit received' || booking.status === 'security deposit') {
              return 'greenColor';
            }
            else if (booking.status === 'fully paid' && i === 0) {
              return 'lower-diagonal-fully-paid';
            }
            else if (booking.status === 'fully paid' && i === booking.booked_dates.length - 1) {
              return 'upper-diagonal-fully-paid';
            }
            else if (booking.status === 'fully paid') {
              return 'fully-paid';
            }
            else if (booking.status === 'on hold' && i === 0) {
              return 'lower-diagonal-on-hold';
            }
            else if (booking.status === 'on hold' && i === booking.booked_dates.length - 1) {
              return 'upper-diagonal-on-hold';
            }
            else if (booking.status === 'on hold') {
              return 'on-hold';
            }
          }
        }
      }
      return;
    };
  }
  // Date click event
  dateChanged(date): void {
    this.searchDialogRef = this._matDialog.open(BookingsCreateModalComponent, {
      panelClass: 'booking-form-dialog',
      data: {
        date: date,
        propertyId: this.id
      }
    });
    this.searchDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.calendarReload.next(true);
        }
      });
  }
}
